import Styled, { keyframes } from 'styled-components';

// Keyframes for shimmer effect
const shimmer = keyframes`
  0% {
    background-position: -500px 0;
  }
  100% {
    background-position: 500px 0;
  }
`;

export const StyledHrSkeletonWrapper = Styled.div`
  width: auto;
  padding: 8px 8px 8px 16px;
  margin: 0;
  display: flex;
  flex-direction: column;

  @media ${(props) => props.theme.mediaQuery.large} {
    padding: 0px 40px 12px 25px;
    gap: 12px;
  }

  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    padding: 0px 40px 12px 25px;
    gap: 0;
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    padding: 0px 40px 12px 25px;
    gap: 6px;
  }
`;

export const StyledHrSkeletonCol = Styled.div`
  width: 174px;
  background-color: ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
  height: 475px;
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    width: 250px;
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    height: 275px;
    width: 230px;
    padding: 10px 20px;
  }
`;

export const StyledHrSkeletonRow = Styled.div`
  background-color: #f4f4f4;
  display: flex;
  min-width: 100%;
  overflow-x: auto;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */

  &::-webkit-scrollbar {
    display: none;  /* Chrome, Safari, Opera*/
  }
  padding: 12px 40px 12px 25px;
    @media ${(props) => props.theme.mediaQuery.large} {
   gap: 18px;
   }
   @media ${(props) => props.theme.mediaQuery.mediumOnly} {
   gap: 18px;
   }
   @media ${(props) => props.theme.mediaQuery.smallOnly} {
  gap: 10px;
   }
`;

export const SkeletonWrapper = Styled.div`
  display: flex;
  flex-direction: column;
  width: 146px;
  height: 332px;
   flex: 0 0 auto;
  flex-wrap: nowrap;
  justify-content: space-between;
    @media ${(props) => props.theme.mediaQuery.large} {
    width: 270px;
    height: 480px;
    }
@media ${(props) => props.theme.mediaQuery.mediumOnly} {
     height: 488px;
      width: 250px;
  }
`;

export const Skeleton = Styled.div`
  background-color: ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
  border-radius: 0px;
  background-image: linear-gradient(
    90deg,
   rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.6),
    rgba(255, 255, 255, 0)
  );
  background-repeat: no-repeat;
  background-size: 800px 104px;
  display: inline-block;
  position: relative;
  overflow: hidden;
  animation: ${shimmer} 0.5s linear infinite;
`;

export const ColorChipSkeleton = Styled(Skeleton)`
  height: 17px;
   width: 30%;
    @media ${(props) => props.theme.mediaQuery.large} {
    height: 24px;
   }
     @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    height: 18px;
   }
`;

export const ImageSkeleton = Styled(Skeleton)`
  height: 158px;
    background-image: linear-gradient(
     90deg,
   rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.6),
    rgba(255, 255, 255, 0)
  );
  background-repeat: no-repeat;
  background-size: 100% 280px;
  width: 100%;
   @media ${(props) => props.theme.mediaQuery.large} {
    height: 280px;
   };
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    height: 288px;
   };
`;

export const PriceSkeleton = Styled(Skeleton)`
  width: 70%;
  height: 17px;
   @media ${(props) => props.theme.mediaQuery.large} {
   height: 24px;
   };
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    height: 24px;
   };
`;

export const NameSkeleton = Styled(Skeleton)`
  width: 100%;
  height: 17px;
  @media ${(props) => props.theme.mediaQuery.large} {
   height: 24px;
  };
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    height: 20px;
   };
`;

export const ButtonSkeleton = Styled(Skeleton)`
  height: 42px;
   @media ${(props) => props.theme.mediaQuery.large} {
   height: 50px;
   }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    height: 42px;
   };
`;

// Styled component for the skeleton row
export const StyleCategoryHeadingRow = Styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

// Styled component for the skeletons
export const StyledHeading = Styled(Skeleton)`
  height: 22px;
  background-color: ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
  margin: 5px;
  width: 163px;

   @media ${(props) => props.theme.mediaQuery.large} {
   height: 28px;
   width: 292px;
   };
     @media ${(props) => props.theme.mediaQuery.mediumOnly} {
     height: 25px;
   width: 204px;
   };
`;

// Styled component for the skeletons
export const StyledViewAll = Styled(Skeleton)`
  height: 14px;
  width: 49px;
  background-color: ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
  margin: 5px;
  @media ${(props) => props.theme.mediaQuery.large} {
   width: 65px;
   height: 22px;
   }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
  height: 14px;
   width: 57px;
   };
`;
